import CustomFieldRichText from './CustomFieldRichText';
import './style/index.less';

export type { CustomFieldRichTextProps, CustomField } from './CustomFieldRichText';

export default CustomFieldRichText;
